"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFactProperty = exports.factPropertyDefinition = void 0;
exports.factPropertyDefinition = {
    view: { label: 'Facts' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: [
                'fact-title',
                'fact-display-sidefact',
                'fact-content-container',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'fact',
};
const isFactProperty = (prop) => {
    return prop.name === exports.factPropertyDefinition.name;
};
exports.isFactProperty = isFactProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFjdC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2ZhY3QucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxzQkFBc0IsR0FBRztJQUNwQyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsT0FBTyxFQUFFO0lBQ3hCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLG1CQUFtQjtZQUN6QixRQUFRLEVBQUU7Z0JBQ1IsWUFBWTtnQkFDWix1QkFBdUI7Z0JBQ3ZCLHdCQUF3QjthQUN6QjtTQUNGO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsbUJBQW1CO0lBQ3pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLE1BQU07Q0FDbUIsQ0FBQTtBQUkxQixNQUFNLGNBQWMsR0FBRyxDQUFDLElBQWtCLEVBQXdCLEVBQUU7SUFDekUsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDhCQUFzQixDQUFDLElBQUksQ0FBQTtBQUNsRCxDQUFDLENBQUE7QUFGWSxRQUFBLGNBQWMsa0JBRTFCIn0=